import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { TrackDialogData } from '../../../services/dialogs.service';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {faXmark} from "@fortawesome/pro-regular-svg-icons";

@Component({
  selector: 'greeting-dialog',
  imports: [
    FaIconComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: 'greeting.dialog.html'
})
export class KexpGreetingDialog {
  protected dialogRef = inject<DialogRef<string>>(DialogRef<string>);
  protected dialogData = inject(DIALOG_DATA) as TrackDialogData;

  protected readonly faXmark = faXmark;

  closeDialog = () => {
    this.dialogRef.close();
  }
}
